import { render, staticRenderFns } from "./StockProductos.vue?vue&type=template&id=9e697420"
import script from "./StockProductos.vue?vue&type=script&lang=js"
export * from "./StockProductos.vue?vue&type=script&lang=js"
import style0 from "./StockProductos.vue?vue&type=style&index=0&id=9e697420&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports